import { render, staticRenderFns } from "./addedit-designation.vue?vue&type=template&id=0935d46b"
import script from "./addedit-designation.vue?vue&type=script&lang=js"
export * from "./addedit-designation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports